@if (categories$ | async; as categories) {
  <div class="categories-line">
    @if (categories.length > 0) {
      <app-carousel>
        @for (category of categories; track category.id) {
          <a
            [draggable]="false"
            [appCategory]="category.name"
            [class.current]="(selectedCategory$ | async) === category.name"
          >
            {{ category.name }}
          </a>
        }
      </app-carousel>
    }
  </div>
}
